import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Clock } from "lucide-react";
import { formatTimeRemaining } from "@/hooks/useSessionTimeout";

interface SessionTimeoutModalProps {
  open: boolean;
  timeRemaining: number;
  onExtend: () => void;
  onLogout: () => void;
}

export function SessionTimeoutModal({
  open,
  timeRemaining,
  onExtend,
  onLogout,
}: SessionTimeoutModalProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-warning/10 rounded-full">
              <Clock className="h-6 w-6 text-warning" />
            </div>
            <AlertDialogTitle className="text-xl">
              Session Timeout Warning
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription asChild>
            <div className="text-base space-y-2 text-muted-foreground">
              <p>
                You've been inactive for a while. Your session will expire in{" "}
                <span className="font-bold text-warning">
                  {formatTimeRemaining(timeRemaining)}
                </span>
                .
              </p>
              <p className="text-sm">
                Click "Stay Logged In" to continue your session, or you'll be
                automatically logged out for security.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onLogout}>Log Out Now</AlertDialogCancel>
          <AlertDialogAction onClick={onExtend}>
            Stay Logged In
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
